module.exports = __webpack_public_path__ + "media/customizations/windsong/logo-97ef0ee271d89b194979fd505333b294.png";